import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface IsDirectSelectProps {
  value?: number;
  onChange?: (value: number) => void;
}

export const IsDirectSelect: VFC<IsDirectSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const directOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: [0, 1],
        suggestedValue: meterModelSuggestions?.isDirect?.value,
        suggestedSelection: meterModelSuggestions?.isDirect?.selection,
        labelFormatter: (value: number) =>
          intl.formatMessage(
            messages[
              value === 1 ? ('direct' satisfies keyof typeof messages) : ('indirect' satisfies keyof typeof messages)
            ],
          ),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={directOptions}
      placeholder={<FormattedMessage {...messages.isDirectPlaceholder} />}
      {...restProps}
    />
  );
};
